// import Backbone from 'backbone';
import tmpl from '../templates';
import ConfigurationItemView from './configurationItemView';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var ConfigurationListView = Backbone.View.extend( {

    el: '#productConfiguration',

    template: _.template( tmpl.configurationList ),

    configurationItemViews: {},

    $optionSet: [],

    initialize: function () {

        this.listenTo( app.configurationList, 'change', function () {
            app.validator.trigger( 'clear:validation' );

            // NOTE: no need to trigger( reset:options ) anymore because the initial option validation occurs
            // when an OptionGroupListView is rendered, so the options get reset upon switching a congifuration
            // app.mediator.trigger( 'reset:options' );
        } );

        this.listenTo( app.configurationList, 'select:group select:sku', this.render );
        this.listenTo( app.configurationList, 'select:configuration', this.renderOptionGroups );

        this.render( this.collection.at( 0 ) );
    },

    close: function () {
        this.unbind();
        this.stopListening( app.configurationList );

        this.remove();
    },

    getNextTarget: function () {
        return _.last( this.$optionSet );
    },

    render: function ( configuration ) {
        this.closeItemViews();
        this.$el.empty();
        this.$optionSet = [];

        this.renderConfigurationTree( configuration );

        return this;
    },

    renderConfigurationTree: function ( configuration ) {
        // recurse over parent tree
        if ( configuration.hasParent() ) {
            var parentConfiguration = this.collection.findWhere( {groupId: configuration.get( 'parentGroupId' )} );
            this.renderConfigurationTree( parentConfiguration );
        }

        return this.$el.append( this.addRowFor( configuration ) );
    },

    renderOptionGroups: function ( configuration ) {
        // todo: to remove unnecessary rendering, delete following render()
        // and store, addRowFor views within a collection with a groupId key to make it easier
        // to close out a selected row
        this.render( configuration );

        // get reference to current configurations ItemView in order to render it's childView::OptionGroupList
        var currentItemView = this.configurationItemViews[configuration.cid];
        this.$el.append( currentItemView.renderOptionGroups() );
    },

    addRowFor: function ( configuration ) {

        var views = [],
            list = this.collection.getSiblingCollection( configuration ),
            // render composite view
            $row = $( this.template( {
                label: configuration.getGroupLabel(),
                groupId: configuration.get( 'parentGroupId' )
            } ) ),
            el = $row.find( '.image-grid' );

        // store a reference to this collection group view
        this.$optionSet.push( $row[0] );

        _.forEach( list, ( item ) => {
            views.push( this.addItem( item ) );
        } );

        el.append( this.showItemViews( views ) );

        return $row;
    },

    addItem: function ( confiigurationItem ) {
        var view = new ConfigurationItemView( {model: confiigurationItem} );

        // store to collection of itemViews so selected configuration can refer to for childViews
        return this.configurationItemViews[confiigurationItem.cid] = view;
    },

    /**
     * Garbage Collection
     * close zombie views/models
     */
    closeItemViews: function () {
        // unbind image error handler
        var existingItems = this._configurationItemViews = this._configurationItemViews || [];
        while ( existingItems.length ) {
            existingItems.pop().close();
        }
        this._configurationItemViews = [];
    },

    showItemViews: function ( views ) {
        this._configurationItemViews = (this._configurationItemViews || []).concat( views );
        return _.map( views, function ( view ) {
            return view.render().el;
        } );
    }

} );

export default ConfigurationListView;
